// Production configuration for the application
// This file is used when building for production

// API URL for production
// Using relative path so it works on any domain
// This will automatically use the same domain as the frontend
export const PRODUCTION_API_URL = '/api';

// Other production-specific configuration
export const PRODUCTION_CONFIG = {
  enableAnalytics: true,
  logLevel: 'error',
  cacheTTL: 3600, // 1 hour in seconds
};

// Instructions for deployment:
// 1. Update PRODUCTION_API_URL to your actual domain where PHP backend is hosted
// 2. Ensure your PHP backend is properly configured with Apache/Nginx
// 3. Set up proper URL rewriting rules in .htaccess for clean API URLs
// 4. Configure PHP environment variables for database connections
// 5. Import this file in src/config/constants.js
// 6. Use the values when NODE_ENV === 'production'
